module.exports = __webpack_public_path__ + "static/media/police-box.9f0a5417.svg";